module.exports = __webpack_public_path__ + "img/basics6.e552c817.png";